<script>
  import { createEventDispatcher, onMount, afterUpdate } from "svelte"
  import Loader from "../../../../../../svg/loader.svelte"
  /**
   * @type {Array} containing one item which is a default item
   */
  export let upwards = false
  export let dropdownItems
  export let selected = {}
  export let count
  export let maxPage
  export let startCount
  export let endCount
  export let page
  export let showLoading
  export let type = "Document"
  const dispatch = createEventDispatcher()

  /**
   * @type {boolean} toggling the dropdown to show and hide
   */
  let showDropdown = false
  /**
   * @type {undefined} binded the overall dropdown parent element
   */
  let dropdown
  /**
   * @type {Array} sorted list of document templates and one default item
   */
  onMount(() => {
    dropdownItems = [
      {
        id: undefined,
        name: "None",
      },
      ...dropdownItems,
    ]
    if (!selected?.name) selected = dropdownItems[0]
  })

  afterUpdate(() => {
    // let selectedItem = dropdownItems.filter((item) => item.id == selected)
    if (!dropdownItems.filter((item) => item.id == undefined).length) {
      dropdownItems = [
        {
          id: undefined,
          name: "None",
        },
        ...dropdownItems,
      ]
    }
    // if (Object.keys(selectedItem).length) {
    //   selectedName = selectedItem[0].name
    // } else {
    //   selectedName = selected
    // }
  })

  /**
   * function to close the dropdown on click anywhere in window
   * @param e-targetting binded value to close drop down
   */
  const onCloseDropDown = (e) => {
    if (dropdown.contains(e.target) == false) showDropdown = false
  }
</script>

<svelte:window on:click={onCloseDropDown} />
<div class="relative w-full" bind:this={dropdown}>
  <button
    on:click={() => {
      showDropdown = !showDropdown
    }}
    type="button"
    class="relative w-full rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-left text-gray-800 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 dark:text-slate-200 sm:text-sm"
  >
    <!-- {temp == 'File' ? 'border-stone-700' : 'border-[#a0a1a580]'} -->
    <div class="flex justify-between">
      <div class="text-sm">{selected?.name == "None" ? `Choose a ${type}` : selected?.name}</div>
      <!-- <div class="text-sm {temp == 'File' ? 'text-white' : 'text-gray-800'} dark:text-slate-200">{selectedName}</div> -->
      <div class="absolute inset-y-0 right-0 flex aspect-square items-center justify-center">
        <i class="fa-solid fa-chevron-down" />
      </div>
    </div>
  </button>
  <div style="padding-inline-start:0px;" class:hidden={!showDropdown} class="absolute {upwards ? 'bottom-10' : ''} z-[999] flex max-h-[180px] w-full flex-col overflow-auto rounded-md border border-[#a0a1a580] bg-white text-base ring-opacity-5 focus:outline-none dark:bg-darkgray sm:text-sm" tabindex="-1">
    <div class="relative flex w-full select-none justify-between bg-slate-50 px-5 py-2 text-gray-800 dark:bg-black dark:text-white">
      <div class="flex items-center gap-6 text-sm">
        <button
          disabled={page == 1 || maxPage == 0}
          on:click={() => {
            dispatch("moveFirst")
          }}
          title="Move to First"
          class="text-gray-200 hover:text-blue-500 disabled:cursor-not-allowed disabled:text-gray-500"
          type="button"
        >
          <i class="fa-solid fa-backward-step" />
        </button>
        <button
          disabled={page == 1 || maxPage == 0}
          title="Newer"
          type="button"
          on:click={() => {
            dispatch("fetchPrevious")
          }}
          class="text-gray-200 hover:text-blue-500 disabled:cursor-not-allowed disabled:text-gray-500"
        >
          <i class="fa-solid fa-chevron-left" />
        </button>
      </div>
      {#if maxPage == 0}
        <div class="text-xs mobile:text-sm">No entries Found</div>
      {:else}
        <div class="text-xs mobile:text-sm">
          <span class="font-mono font-bold text-blue-500">{startCount}</span>
          -
          <span class="font-mono font-bold text-blue-500">{endCount}</span>
          of
          <span class="font-mono font-bold text-blue-500">{count}</span>
          entries
        </div>
      {/if}
      <div class="flex items-center gap-6 text-sm">
        <button
          disabled={maxPage == page || maxPage == 0}
          type="button"
          title="Older"
          on:click={() => {
            dispatch("fetchNext")
          }}
          class="text-gray-200 hover:text-blue-500 disabled:cursor-not-allowed disabled:text-gray-500"
        >
          <i class="fa-solid fa-chevron-right" />
        </button>
        <button
          disabled={maxPage == page || maxPage == 0}
          on:click={() => {
            dispatch("moveLast")
          }}
          title="Move to Last"
          class="text-gray-200 hover:text-blue-500 disabled:cursor-not-allowed disabled:text-gray-500"
          type="button"
        >
          <i class="fa-solid fa-forward-step" />
        </button>
      </div>
    </div>
    <ul class="relative flex max-h-56 w-full flex-col overflow-auto">
      {#if !showLoading}
        {#each dropdownItems as item}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <li
            on:click={(e) => {
              selected = item
              dispatch("itemSelect", item)
              // dispatch("selectedName", item)
              showDropdown = false
            }}
            class="relative cursor-pointer select-none rounded-md px-5 py-2 {selected?.id == item.id ? `bg-blue-500 hover:bg-none` : 'bg-transparent  hover:bg-[#f7f7f7] dark:hover:bg-black'} text-gray-800 dark:text-gray-200 dark:hover:bg-black dark:hover:text-white"
          >
            <div class="flex items-center dark:hover:bg-black">
              <div class="text-sm {selected?.id == item.id ? `font-semibold text-white` : ''}">{item.name}</div>
            </div>
          </li>
        {/each}
      {:else}
        <div class="flex h-56 items-center justify-center text-base text-gray-400">
          <!-- <Loader background={temp == "File" ? "bg-gray-f00" : "bg-white/50"}>
            <span class="flex">
              {@html `Fetching ${type} Templates List&nbsp;&nbsp;`}
            </span>
          </Loader> -->
          <div class="absolute inset-0 -top-3 z-30 flex select-none flex-col items-center justify-center gap-3 rounded-md bg-white/50 backdrop-blur-md dark:bg-darkgray/50">
            <div class=" flex h-full items-center justify-center text-center text-base text-gray-400 dark:text-slate-100">
              {@html `Fetching ${type} List&nbsp;&nbsp;`}

              <Loader />
            </div>
          </div>
        </div>
      {/if}
    </ul>
  </div>
</div>
